export const iconFontAwesomeMapsLocationDot = (
	<i className="fa-solid fa-location-dot"></i>
);
